import styles from './Avatar.module.css';

export type AvatarSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export type AvatarProps = {
  name?: string;
  src?: string;
  alt?: string;
  size?: AvatarSize;
};

function getInitials(name?: string): string {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0]!.slice(0, 2);
  return `${parts[0]![0]!}${parts[parts.length - 1]![0]!}`;
}

export function Avatar({ name, src, alt, size = 'md' }: AvatarProps) {
  const classes = `${styles.avatar} ${styles[`size-${size}`]}`;
  if (src) {
    return (
      <span className={classes}>
        <img src={src} alt={alt ?? name ?? 'avatar'} className={styles.img} />
      </span>
    );
  }
  return <span className={classes}>{getInitials(name)}</span>;
}
